(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["learning-flip-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('learning-flip-cards')) {
    customElements.define('learning-flip-cards', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        if (this.dataset.fontAwesome === 'true' && !document.querySelector('link[data-lfc-font-awesome]')) {
          const stylesheet = document.createElement('link');
          stylesheet.rel = 'stylesheet';
          stylesheet.href = 'https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@6.7.2/css/all.min.css';
          stylesheet.dataset.lfcFontAwesome = '';
          document.head.appendChild(stylesheet);
        }
        const on = (target, event, fn) => target.addEventListener(event, fn, { signal: this.abort.signal });
        this.track = this.querySelector('.lfc__track');
        this.cards = [...this.querySelectorAll('.lfc__card')];
        if (!this.cards.length) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.hover = matchMedia('(hover: hover) and (pointer: fine)');
        this.paused = this.motion.matches;
        this.visible = false;
        this.index = 0;
        this.play = this.querySelector('[data-play]');
        this.updatePlay();
        this.cards.forEach(card => {
          on(card, 'pointerenter', () => { if (this.hover.matches) this.flip(card, true); });
          on(card, 'pointerleave', () => { if (this.hover.matches && !card.contains(document.activeElement)) this.flip(card, false); });
          on(card, 'click', event => {
            if (event.target.closest('.lfc__flip, [data-details]') || !event.target.closest('a, button')) this.flip(card, !card.classList.contains('is-flipped'));
          });
          on(card, 'keydown', event => { if (event.key === 'Escape') { this.flip(card, false); card.querySelector('.lfc__flip').focus(); } });
          on(card, 'focusout', () => queueMicrotask(() => { if (!card.contains(document.activeElement) && !card.matches(':hover')) this.flip(card, false); }));
        });
        on(this, 'pointerenter', () => { this.pointerInside = true; this.schedule(); });
        on(this, 'pointerleave', () => { this.pointerInside = false; this.schedule(); });
        on(this, 'focusin', () => this.schedule());
        on(this, 'focusout', () => queueMicrotask(() => this.schedule()));
        on(this.track, 'scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.measure());
          this.schedule();
        });
        on(this.querySelector('[data-prev]'), 'click', () => this.move(-1, true));
        on(this.querySelector('[data-next]'), 'click', () => this.move(1, true));
        if (this.play) on(this.play, 'click', () => { this.paused = !this.paused; this.updatePlay(); this.schedule(); });
        on(document, 'visibilitychange', () => this.schedule());
        on(this.motion, 'change', () => { if (this.motion.matches) this.paused = true; this.updatePlay(); this.schedule(); });
        on(document, 'shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.blockId === event.detail.blockId);
          if (!card) return;
          this.editing = true;
          this.go(this.cards.indexOf(card));
          this.schedule();
        });
        on(document, 'shopify:block:deselect', () => { this.editing = false; this.schedule(); });
        this.resize = new ResizeObserver(() => { this.measure(); this.schedule(); });
        this.resize.observe(this.track);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: 0.15 });
        this.observer.observe(this);
        this.measure();
      }
      flip(card, flipped) {
        const front = card.querySelector('.lfc__front');
        const back = card.querySelector('.lfc__back');
        const outgoing = flipped ? front : back;
        const incoming = flipped ? back : front;
        const focused = outgoing.contains(document.activeElement);
        const focusedCTA = focused && document.activeElement.classList.contains('lfc__cta');
        card.classList.toggle('is-flipped', flipped);
        incoming.inert = false;
        incoming.setAttribute('aria-hidden', 'false');
        if (focused) incoming.querySelector(focusedCTA ? '.lfc__cta' : '.lfc__flip').focus({ preventScroll: true });
        outgoing.inert = true;
        outgoing.setAttribute('aria-hidden', 'true');
        card.querySelectorAll('.lfc__flip').forEach(toggle => toggle.setAttribute('aria-expanded', String(flipped)));
        this.schedule();
      }
      measure() {
        const rect = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const distances = this.cards.map(card => { const r = card.getBoundingClientRect(); return Math.abs(rtl ? rect.right - r.right : r.left - rect.left); });
        this.index = distances.indexOf(Math.min(...distances));
        this.querySelector('[data-current]').textContent = String(this.index + 1).padStart(2, '0');
        this.canScroll = this.track.scrollWidth > this.track.clientWidth + 2;
        this.querySelectorAll('.lfc__arrow').forEach(button => { button.disabled = !this.canScroll; });
      }
      go(index) {
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const first = this.cards[0].getBoundingClientRect();
        const target = this.cards[index].getBoundingClientRect();
        this.track.scrollTo({ left: rtl ? target.right - first.right : target.left - first.left, behavior: this.motion.matches ? 'instant' : 'smooth' });
      }
      move(direction, announce = false) {
        const end = Math.abs(this.track.scrollLeft) >= this.track.scrollWidth - this.track.clientWidth - 3;
        let next = this.index + direction;
        if (direction > 0 && end) next = 0;
        if (next < 0) next = this.cards.length - 1;
        this.go(Math.min(next, this.cards.length - 1));
        if (announce) this.querySelector('[data-announcement]').textContent = direction > 0 ? 'Showing next cards' : 'Showing previous cards';
        this.schedule();
      }
      updatePlay() {
        if (!this.play) return;
        this.play.textContent = this.paused ? '▶' : 'Ⅱ';
        this.play.setAttribute('aria-label', this.paused ? 'Start autoplay' : 'Pause autoplay');
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.dataset.autoplay !== 'true' || this.paused || !this.visible || !this.canScroll || document.hidden || this.pointerInside || this.contains(document.activeElement) || this.editing || this.querySelector('.is-flipped')) return;
        this.timer = setTimeout(() => this.move(1), Number(this.dataset.interval) || 4500);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        this.observer?.disconnect();
        clearTimeout(this.timer);
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
